"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); //      


var _request = require("../common/request");

var _request2 = _interopRequireDefault(_request);

var _constants = require("./constants");

var CONSTANTS = _interopRequireWildcard(_constants);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

require("moment/locale/ca");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Share = function () {
    function Share() {
        _classCallCheck(this, Share);
    }

    _createClass(Share, null, [{
        key: "getStylesFromPredefinedScales",
        value: function getStylesFromPredefinedScales(tematicField, scaleName) {
            var SCALES = {
                TemperaturaMeteocat: ["interpolate", ["exponential", 1], ["number", ["get", tematicField]], -18, "rgb(0,0,168)", -16, "rgb(66,22,202)", -14, "rgb(80,46,189)", -12, "rgb(93,69,175)", -10, "rgb(110,94,160)", -8, "rgb(100,0,100)", -6, "rgb(126,38,126)", -4, "rgb(155,79,155)", -2, "rgb(186,122,186)", 0, "rgb(205,150,205)", 2, "rgb(204,255,255)", 4, "rgb(164,236,239)", 6, "rgb(134,216,217)", 8, "rgb(106,194,209)", 10, "rgb(65,157,171)", 12, "rgb(1,134,45)", 14, "rgb(3,194,40)", 16, "rgb(0,255,64)", 18, "rgb(123,241,123)", 20, "rgb(201,255,148)", 22, "rgb(241,242,136)", 24, "rgb(241,207,101)", 26, "rgb(240,171,65)", 28, "rgb(240,138,31)", 30, "rgb(240,107,0)", 32, "rgb(255,102,102)", 34, "rgb(255,70,70)", 36, "rgb(255,0,0)", 38, "rgb(178,34,34)", 40, "rgb(155,0,0)", 42, "rgb(115,0,0)", 50, "rgb(79,0,0)"],
                VentMeteocat: ["interpolate", ["exponential", 1], ["number", ["get", tematicField]], 0, "rgb(18,244,244)", 5, "rgb(8,159,252)", 10, "rgb(14,81,248)", 20, "rgb(16,13,112)", 30, "rgb(95,255,0)", 40, "rgb(1,206,63)", 50, "rgb(56,144,0)", 60, "rgb(32,95,1)", 70, "rgb(255,255,0)", 80, "rgb(255,235,0)", 90, "rgb(255,170,0)", 100, "rgb(230,76,0)", 125, "rgb(255,0,0)", 150, "rgb(168,0,0)", 175, "rgb(115,0,0)", 1000, "rgb(115,0,0)"],
                HRMeteocat: ["interpolate", ["exponential", 1], ["number", ["get", tematicField]], 0, "rgb(120,0,0)", 5, "rgb(153,0,0)", 10, "rgb(204,51,0)", 15, "rgb(255,0,0)", 20, "rgb(255,102,102)", 25, "rgb(255,102,51)", 30, "rgb(255,153,51)", 35, "rgb(255,204,0)", 40, "rgb(255,255,0)", 45, "rgb(153,255,0)", 50, "rgb(0,255,0)", 55, "rgb(20,204,20)", 60, "rgb(0,140,0)", 65, "rgb(0,255,200)", 70, "rgb(0,255,255)", 75, "rgb(0,150,250)", 80, "rgb(0,80,255)", 85, "rgb(0,0,255)", 90, "rgb(100,51,204)", 95, "rgb(153,0,153)", 100, "rgb(153,0,153)"],
                pptMeteocat: ["interpolate", ["exponential", 1], ["number", ["get", tematicField]], 0, "rgb(255,255,255)", 0.2, "rgb(170,219,250)", 1, "rgb(110,192,255)", 5, "rgb(66,170,255)", 10, "rgb(0,149,255)", 20, "rgb(0,115,255)", 30, "rgb(0,76,255)", 40, "rgb(0,26,255)", 50, "rgb(77,26,255)", 75, "rgb(122,0,245)", 100, "rgb(171,0,245)", 150, "rgb(196,0,245)", 200, "rgb(245,0,245)", 1000, "rgb(245,0,245)"],
                Vent: ["interpolate", ["exponential", 1], ["number", ["get", tematicField]], 0, "rgb(18,244,244)", 1, "rgb(8,159,252)", 5, "rgb(14,81,248)", 10, "rgb(16,13,112)", 20, "rgb(95,255,0)", 30, "rgb(1,206,63)", 40, "rgb(56,144,0)", 50, "rgb(32,95,1)", 60, "rgb(255,255,0)", 70, "rgb(255,235,0)", 80, "rgb(255,170,0)", 90, "rgb(230,76,0)", 100, "rgb(255,0,0)", 125, "rgb(255,0,0)", 150, "rgb(122,0,245)", 200, "rgb(51,51,51)"],
                Temperatura: ["interpolate", ["exponential", 1], ["number", ["get", tematicField]], -30, "rgb(109,0,109)", -25, "rgb(127,0,127)", -23, "rgb(149,0,149)", -21, "rgb(170,0,170)", -19, "rgb(200,0,200)", -15, "rgb(226,0,226)", -13, "rgb(68,22,171)", -11, "rgb(61,12,199)", -9, "rgb(65,8,255)", -7, "rgb(3,82,230)", -5, "rgb(3,113,230)", -3, "rgb(19,144,230)", -1, "rgb(46,182,230)", 1, "rgb(88,219,230)", 3, "rgb(37,157,0)", 5, "rgb(64,170,0)", 7, "rgb(87,183,0)", 9, "rgb(131,207,0)", 11, "rgb(164,225,5)", 13, "rgb(191,242,9)", 15, "rgb(215,252,25)", 17, "rgb(253,255,2)", 19, "rgb(255,232,2)", 21, "rgb(255,206,9)", 23, "rgb(250,173,0)", 25, "rgb(252,142,0)", 28, "rgb(246,116,0)", 31, "rgb(255,90,0)", 33, "rgb(255,60,0)", 35, "rgb(245,1,47)", 37, "rgb(219,1,42)", 39, "rgb(198,1,38)", 42, "rgb(170,1,33)", 44, "rgb(138,17,32)", 46, "rgb(105,17,32)", 48, "rgb(78,0,32)", 50, "rgb(65,0,27)", 52, "rgb(48,0,9)"],
                TemperaturaXafogor: ["interpolate", ["exponential", 1], ["number", ["get", tematicField]], 20, "rgba(255,255,255,0.3)", 21, "rgb(250,173,0)", 23, "rgb(252,142,0)", 25, "rgb(246,116,0)", 28, "rgb(255,90,0)", 31, "rgb(255,60,0)", 33, "rgb(245,1,47)", 35, "rgb(219,1,42)", 37, "rgb(198,1,38)", 39, "rgb(170,1,33)", 42, "rgb(138,17,32)", 44, "rgb(105,17,32)", 46, "rgb(78,0,32)", 48, "rgb(65,0,27)", 50, "rgb(48,0,9)", 52, "rgb(255,255,255)"],
                TemperaturaSensacio: ["interpolate", ["exponential", 1], ["number", ["get", tematicField]], -30, "rgb(109,0,109)", -25, "rgb(127,0,127)", -23, "rgb(149,0,149)", -21, "rgb(170,0,170)", -19, "rgb(200,0,200)", -15, "rgb(226,0,226)", -13, "rgb(68,22,171)", -11, "rgb(61,12,199)", -9, "rgb(65,8,255)", -7, "rgb(3,82,230)", -5, "rgb(3,113,230)", -3, "rgb(19,144,230)", -1, "rgb(46,182,230)", 1, "rgb(88,219,230)", 3, "rgb(37,157,0)", 5, "rgb(64,170,0)", 7, "rgb(87,183,0)", 9, "rgb(131,207,0)"],
                ComparativaTemperatura: ["interpolate", ["exponential", 1], ["number", ["get", tematicField]], -20, "rgb(184,192,195)", -18, "rgb(158,151,171)", -16, "rgb(129,102,141)", -15, "rgb(106,68,119)", -14, "rgb(109,0,109)", -13, "rgb(127,0,127)", -12, "rgb(149,0,149)", -11, "rgb(170,0,170)", -10, "rgb(200,0,200)", -9, "rgb(226,0,226)", -8, "rgb(68,22,171)", -7, "rgb(61,12,199)", -6, "rgb(65,8,255)", -5, "rgb(3,82,230)", -4, "rgb(3,113,230)", -3, "rgb(19,144,230)", -2, "rgb(46,182,230)", -1, "rgb(88,219,230)", 0, "rgb(253,255,209)", 1, "rgb(250,253,153)", 2, "rgb(243,249,79)", 3, "rgb(253,255,2)", 4, "rgb(255,232,2)", 5, "rgb(255,206,9)", 6, "rgb(250,173,0)", 7, "rgb(252,142,0)", 8, "rgb(246,116,0)", 9, "rgb(255,90,0)", 10, "rgb(255,60,0)", 11, "rgb(245,1,47)", 12, "rgb(219,1,42)", 13, "rgb(198,1,38)", 14, "rgb(170,1,33)", 15, "rgb(138,17,32)", 16, "rgb(105,17,32)", 18, "rgb(78,0,32)", 20, "rgb(65,0,27)"],
                AmplitudTermica: ["interpolate", ["exponential", 1], ["number", ["get", tematicField]], 0, "rgb(109,0,109)", 1, "rgb(127,0,127)", 3, "rgb(149,0,149)", 5, "rgb(170,0,170)", 7, "rgb(200,0,200)", 9, "rgb(226,0,226)", 11, "rgb(68,22,171)", 13, "rgb(61,12,199)", 15, "rgb(65,8,255)", 17, "rgb(3,82,230)", 19, "rgb(3,113,230)", 21, "rgb(19,144,230)", 23, "rgb(46,182,230)", 25, "rgb(88,219,230)", 28, "rgb(37,157,0)", 31, "rgb(64,170,0)", 33, "rgb(87,183,0)", 35, "rgb(131,207,0)", 37, "rgb(164,225,5)", 39, "rgb(191,242,9)", 42, "rgb(215,252,25)", 44, "rgb(253,255,2)", 46, "rgb(255,232,2)", 48, "rgb(255,206,9)", 50, "rgb(250,173,0)", 52, "rgb(252,142,0)"],
                Humitat: ["interpolate", ["exponential", 1], ["number", ["get", tematicField]], 0, "rgba(255,255,255,0.3)", 20, "rgba(255,255,255,0.3)", 30, "rgb(255,51,51)", 40, "rgb(255,153,51)", 50, "rgb(255,255,0)", 55, "rgb(128,255,64)", 60, "rgb(0,255,176)", 65, "rgb(0,255,255)", 70, "rgb(0,228,248)", 75, "rgb(0,200,240)", 80, "rgb(0,116,216)", 95, "rgb(0,0,192)", 100, "rgb(50,50,50)"],
                CotaNeu: ["interpolate", ["exponential", 1], ["number", ["get", tematicField]], 100, "rgb(0,0,192)", 200, "rgb(0,60,200)", 300, "rgb(0,88,208)", 400, "rgb(0,116,216)", 500, "rgb(0,144,224)", 600, "rgb(0,172,232)", 700, "rgb(0,200,240)", 800, "rgb(0,228,248)", 900, "rgb(0,255,255)", 1000, "rgb(0,255,176)", 1100, "rgb(128,255,64)", 1200, "rgb(192,255,0)", 1300, "rgb(255,255,0)", 1400, "rgb(255,236,0)", 1500, "rgb(255,216,0)", 1600, "rgb(255,196,0)", 1700, "rgb(255,176,0)", 1800, "rgb(255,156,0)", 1900, "rgb(255,136,0)", 2000, "rgb(255,112,0)", 2100, "rgb(255,80,0)", 2200, "rgb(255,0,0)", 2300, "rgb(240,0,48)", 2400, "rgb(224,0,72)", 2500, "rgb(208,0,96)", 2600, "rgb(192,0,120)", 2700, "rgb(208,0,144)", 2800, "rgb(224,0,168)", 2900, "rgb(240,0,192)", 3000, "rgb(255,0,216)", 3100, "rgb(255,64,255)", 3200, "rgb(255,104,255)"],
                PlujaHora: ["interpolate", ["exponential", 1], ["number", ["get", tematicField]], 0, "rgba(255,255,255,0.3)", 0.1, "rgb(170,255,255)", 0.5, "rgb(83,210,255)", 1, "rgb(42,170,255)", 2, "rgb(28,126,217)", 3, "rgb(14,63,217)", 4, "rgb(75,25,75)", 6, "rgb(153,51,153)", 10, "rgb(210,0,210)", 20, "rgb(255,0,255)"],
                PlujaDia: ["interpolate", ["exponential", 1], ["number", ["get", tematicField]], 0, "rgba(255,255,255,0.3)", 1, "rgb(170,255,255)", 2, "rgb(83,210,255)", 3, "rgb(42,170,255)", 4, "rgb(28,126,217)", 6, "rgb(14,63,217)", 10, "rgb(75,25,75)", 20, "rgb(153,51,153)", 50, "rgb(210,0,210)", 100, "rgb(255,0,255)"],
                PlujaMes: ["interpolate", ["exponential", 1], ["number", ["get", tematicField]], 0, "rgba(255,255,255,0.3)", 5, "rgb(170,255,255)", 10, "rgb(83,210,255)", 20, "rgb(42,170,255)", 30, "rgb(28,126,217)", 40, "rgb(14,63,217)", 60, "rgb(75,25,75)", 100, "rgb(153,51,153)", 200, "rgb(210,0,210)", 250, "rgb(255,0,255)"],
                PlujaAny: ["interpolate", ["exponential", 1], ["number", ["get", tematicField]], 0, "rgba(255,255,255,0.3)", 200, "rgb(170,255,255)", 300, "rgb(83,210,255)", 400, "rgb(42,170,255)", 500, "rgb(28,126,217)", 600, "rgb(14,63,217)", 700, "rgb(75,25,75)", 800, "rgb(153,51,153)", 900, "rgb(210,0,210)", 1200, "rgb(255,0,255)"],
                NeuHora: ["interpolate", ["exponential", 1], ["number", ["get", tematicField]], 0, "rgba(255,255,255,0.3)", 0.1, "rgb(0,255,0)", 0.5, "rgb(127,255,0)", 1, "rgb(76,187,23)", 2, "rgb(80,200,120)", 3, "rgb(0,168,107)", 4, "rgb(64,130,109)", 6, "rgb(68,148,74)", 10, "rgb(123,160,91)", 20, "rgb(107,142,35)"],
                NeuDia: ["interpolate", ["exponential", 1], ["number", ["get", tematicField]], 0, "rgba(255,255,255,0.3)", 1, "rgb(0,255,0)", 2, "rgb(127,255,0)", 3, "rgb(76,187,23)", 4, "rgb(80,200,120)", 6, "rgb(0,168,107)", 10, "rgb(64,130,109)", 20, "rgb(68,148,74)", 50, "rgb(123,160,91)", 100, "rgb(107,142,35)"],
                NeuMes: ["interpolate", ["exponential", 1], ["number", ["get", tematicField]], 0, "rgba(255,255,255,0.3)", 5, "rgb(0,255,0)", 10, "rgb(127,255,0)", 20, "rgb(76,187,23)", 30, "rgb(80,200,120)", 40, "rgb(0,168,107)", 60, "rgb(64,130,109)", 100, "rgb(68,148,74)", 200, "rgb(123,160,91)", 250, "rgb(107,142,35)"],
                NeuAny: ["interpolate", ["exponential", 1], ["number", ["get", tematicField]], 0, "rgba(255,255,255,0.3)", 200, "rgb(0,255,0)", 300, "rgb(127,255,0)", 400, "rgb(76,187,23)", 500, "rgb(80,200,120)", 600, "rgb(0,168,107)", 700, "rgb(64,130,109)", 800, "rgb(68,148,74)", 900, "rgb(123,160,91)", 1200, "rgb(107,142,35)"]
            };
            var _style = SCALES.TemperaturaMeteocat;
            Object.keys(SCALES).forEach(function (key, i) {
                if (key === scaleName) {
                    _style = SCALES[key];
                }
            });
            return _style;
        }
    }, {
        key: "getObtionsByActiveField",
        value: function getObtionsByActiveField(activeField) {
            try {
                if (activeField.indexOf("temp") !== -1 || activeField.indexOf("windchill") !== -1 || activeField.indexOf("humidex") !== -1) {
                    return _extends({}, CONSTANTS.RANGS_VALORS_CHARTS.temperatura);
                } else if (activeField.indexOf("vent") !== -1) {
                    return _extends({}, CONSTANTS.RANGS_VALORS_CHARTS.vent);
                } else if (activeField.indexOf("humit") !== -1) {
                    return _extends({}, CONSTANTS.RANGS_VALORS_CHARTS.humitat);
                } else {
                    return _extends({}, CONSTANTS.RANGS_VALORS_CHARTS[activeField]);
                }
            } catch (err) {
                console.error("getObtionsByActiveField: ".err);
                return _extends({}, CONSTANTS.DEFAULT_RANGS_VALORS_CHARTS);
            }
        }
    }, {
        key: "getArrayDifferences",
        value: function getArrayDifferences(a, b) {
            return [].concat(_toConsumableArray(a.filter(function (x) {
                return b.indexOf(x) === -1;
            })), _toConsumableArray(b.filter(function (x) {
                return a.indexOf(x) === -1;
            })));
        }
    }, {
        key: "loadJsonConfig",
        value: function loadJsonConfig(url, id) {
            return new Promise(function (resolve, reject) {
                _request2.default.get(url + "/" + id).then(function (data) {
                    return resolve(data);
                }).catch(function (error) {
                    return reject(error);
                });
            });
        }
    }, {
        key: "getLocalDataByStation",
        value: function getLocalDataByStation(station, database, timestamp) {
            var _database = database + "_histo" + new Date(timestamp).getFullYear().toString();
            //let resp=[];
            //console.info("DatabesaName", _database);
            return new Promise(function (resolve, reject) {
                _request2.default.post(CONSTANTS.URL_GET_LOCALDATA, { database: _database, station: station, timestamp: timestamp }).then(function (response) {
                    if (response) {
                        resolve(response);
                    }
                }).catch(function () {
                    return reject(null);
                });
            });
        }
    }, {
        key: "getUserLogged",
        value: function getUserLogged(galeta) {
            return new Promise(function (resolve) {
                _request2.default.post(CONSTANTS.checkSession, { token: galeta }).then(function (isLogged) {
                    //console.info("isLogged", isLogged)
                    if (isLogged.status === "OK") {
                        resolve(true);
                    } else {
                        resolve(false);
                    }
                }).catch(function () {
                    return resolve(false);
                });
            });
        }
    }, {
        key: "getLastVisor",
        value: function getLastVisor() {
            return new Promise(function (resolve, reject) {
                _request2.default.get(CONSTANTS.URL_GET_CONFIG).then(function (data) {
                    //console.info(data);
                    resolve(data[0].apps.visor);
                }).catch(function (error) {
                    return reject(error);
                });
            });
        }
    }, {
        key: "generateListCalcValues",
        value: function generateListCalcValues(calcdatafieldsCalculs) {
            //TODO quan afegim frequencies, etc. modificar.
            //NO FER AIXÍ
            var list = [];
            if (calcdatafieldsCalculs._value === true) list.push(CONSTANTS.OPT_CALCULS[0]);
            if (calcdatafieldsCalculs._min === true) list.push(CONSTANTS.OPT_CALCULS[2]);
            if (calcdatafieldsCalculs._max === true) list.push(CONSTANTS.OPT_CALCULS[1]);
            if (calcdatafieldsCalculs._mean === true) list.push(CONSTANTS.OPT_CALCULS[3]);
            if (calcdatafieldsCalculs._sum === true) list.push(CONSTANTS.OPT_CALCULS[4]);
            if (calcdatafieldsCalculs._calcvalue === true) list.push(CONSTANTS.OPT_CALCULS[5]);
            return list;
        }
    }, {
        key: "checkDinamicTimeRange",
        value: function checkDinamicTimeRange(timerange) {
            var option = CONSTANTS.RANG_TEMPORAL_OPCIONS.find(function (elem) {
                return elem.value === timerange.tipus;
            });
            if (timerange.dynamic === true && option) {
                if (timerange.tipus === CONSTANTS.CUSTOM) {
                    //timerange.timemin = moment().subtract(option.daystosubstractstartdate, "days").format("YYYY-MM-DD");
                    timerange.timemax = (0, _moment2.default)().subtract(option.daystosubstractenddate, "days").format("YYYY-MM-DD");
                } else {
                    timerange.timemin = (0, _moment2.default)().subtract(option.daystosubstractstartdate, "days").format("YYYY-MM-DD");
                    timerange.timemax = (0, _moment2.default)().subtract(option.daystosubstractenddate, "days").format("YYYY-MM-DD");
                }
            }
            return timerange;
        }
    }, {
        key: "formatDateRange",
        value: function formatDateRange(date) {
            return (0, _moment2.default)(date).format("DD/MM/YYYY");
        }
    }, {
        key: "formatDateAll",
        value: function formatDateAll(date) {
            return (0, _moment2.default)(date).format();
        }
    }, {
        key: "formatDateHour",
        value: function formatDateHour(date) {
            return (0, _moment2.default)(date).format("YYYY-MM-DD HH");
        }
    }, {
        key: "formatDateMomentLocal",
        value: function formatDateMomentLocal(date) {
            if (date && date !== null) {
                date = date.replace("h", "");
            }
            if (date.indexOf("/") !== -1) {
                var newDate = (0, _moment2.default)(date, "DD/MM/YYYY HH:ss").format("dddd, DD/MM/YYYY HH:ss");
                if (newDate) {
                    return newDate + "h";
                } else {
                    return date + "h";
                }
            } else if (date === null || date == "null") {
                return "";
            } else {
                return date;
            }
        }
    }, {
        key: "changeFormatArrayString",
        value: function changeFormatArrayString(dateArray) {
            var newDateArray = [];
            for (var i = 0; i < dateArray.length; i++) {
                var part1 = dateArray[i].toString().replace("h", "").split(" ");
                var part2 = part1[0].toString().split("/");
                newDateArray.push(part2[2] + "-" + part2[1] + "-" + part2[0] + " " + part1[1]);
            }
            return newDateArray;
        }
    }, {
        key: "formatDateMoment",
        value: function formatDateMoment(date) {
            if (date && date !== null) {
                date = date.replace("h", "");
            }
            if (!isNaN(new Date(date).getTime()) && date !== null) {
                if (date.indexOf("-") !== -1) {
                    var newDate = (0, _moment2.default)(date, "YYYY-MM-DD HH:ss").format("dddd, DD/MM/YYYY HH:ss");
                    if (newDate) {
                        return newDate + "h";
                    } else {
                        return date + "h";
                    }
                }
                if (date.indexOf("/") !== -1) {
                    var _newDate = (0, _moment2.default)(date, "DD/MM/YYYY HH:ss").format("dddd, DD/MM/YYYY HH:ss");
                    if (_newDate) {
                        return _newDate + "h";
                    } else {
                        return date + "h";
                    }
                }
                //return date;
            } else if (date === null || date == "null") {
                date = "";
                return "";
            } else {
                return date;
            }
        }
    }, {
        key: "joinTimesAndValuesPlujaV2",
        value: function joinTimesAndValuesPlujaV2(timestamps, JSONActiveFiles, lastValue) {
            var _valueMostra = [];
            var fakeValue = JSONActiveFiles[0];
            var needReset = false;
            if (timestamps[0].indexOf("00:00:00") !== -1 && fakeValue) {
                JSONActiveFiles[0] = 0;
                if (Object.keys(JSONActiveFiles).length === 1 && fakeValue === lastValue) {
                    needReset = true;
                }
            }
            for (var i = 0; i < timestamps.length; i++) {
                if (typeof JSONActiveFiles[i] === "number") {
                    //const _data = isNaN(new Date(timestamps[i]).getTime()) ? timestamps[i] : new Date(timestamps[i]);
                    var _hora = parseInt((0, _moment2.default)(timestamps[i]).format("H"));
                    if ((0, _moment2.default)(timestamps[i]).format("YYYY-MM-DD") === (0, _moment2.default)(timestamps[i - 1]).format("YYYY-MM-DD") && _hora >= 0 && _hora <= 23) {
                        var _anterior = isNaN(JSONActiveFiles[i - 1]) ? 0 : JSONActiveFiles[i - 1];
                        _anterior = _anterior < 0 ? 0 : _anterior;
                        var valor = JSONActiveFiles[i] - _anterior;
                        valor = valor > 0 ? valor : 0;
                        _valueMostra.push(valor);
                    } else {
                        _valueMostra.push(JSONActiveFiles[i]);
                    }
                }
            }
            var sum = _valueMostra.reduce(function (a, b) {
                return a + b;
            }, 0);
            var newFilterValue = _valueMostra.filter(function (_valueMostra) {
                return _valueMostra > 0;
            });
            var min = newFilterValue.length > 0 ? parseFloat(Math.min.apply(Math, _toConsumableArray(newFilterValue)).toFixed(1)) : 0;
            var max = newFilterValue.length > 0 ? parseFloat(Math.max.apply(Math, _toConsumableArray(newFilterValue)).toFixed(1)) : 0;
            return {
                "min": min,
                "max": max,
                "sum": parseFloat(sum.toFixed(1)),
                "mean": parseFloat((sum / timestamps.length).toFixed(2)),
                "mostra": _valueMostra,
                "needReset": needReset
            };
        }
    }, {
        key: "joinTimesAndValuesPluja",
        value: function joinTimesAndValuesPluja(timestamps, JSONActiveFiles) {
            var maxValue = [];
            var map = new Map();
            var times = [];
            //console.info("JSONActiveFiles", JSONActiveFiles);
            timestamps.forEach(function (item, index) {
                var _newItem = (0, _moment2.default)(item).format("YYYY-MM-DD");
                var key = JSONActiveFiles[index];
                if (typeof key === "number") {
                    //console.info("KEYnumber", key);
                    times.push(key);
                    if (!map.has(_newItem)) {
                        map.set(_newItem, [key]);
                    } else {
                        map.get(_newItem).push(key);
                    }
                } else if (key === null) {
                    times.push(key);
                    if (!map.has(_newItem)) {
                        map.set(_newItem, [0]);
                    } else {
                        map.get(_newItem).push(0);
                    }
                }
            });
            map.forEach(function (item) {
                maxValue.push(Math.max.apply(Math, _toConsumableArray(item)));
            });
            var sum = maxValue.reduce(function (a, b) {
                return a + b;
            }, 0);
            return {
                "sum": parseFloat(sum.toFixed(1)),
                "mean": parseFloat((sum / times.length).toFixed(2))
            };
        }
    }, {
        key: "stylePadingFromStylesColor",
        value: function stylePadingFromStylesColor(arrayStyle) {
            for (var i = 0; i < arrayStyle.length; i++) {
                var item = arrayStyle[i];
                if (typeof item === "string" && (item.indexOf("rgb") !== -1 || item.indexOf("#") !== -1)) {
                    if (i === 2 || i === 4) {
                        arrayStyle[i] = 1;
                    } else if (i == arrayStyle.length - 1) {
                        arrayStyle[i] = 2; //maxim
                    } else if (i == arrayStyle.length - 3) {
                        arrayStyle[i] = 1;
                    } else {
                        arrayStyle[i] = 0.4;
                    }
                }
            }
            return arrayStyle;
        }
    }, {
        key: "styleBadgesFromStylesColor",
        value: function styleBadgesFromStylesColor(arrayStyle) {
            //groc road_6_21
            for (var i = 0; i < arrayStyle.length; i++) {
                var item = arrayStyle[i];
                if (typeof item === "string" && (item.indexOf("rgb") !== -1 || item.indexOf("#") !== -1)) {
                    if (i === 2) {
                        arrayStyle[i] = "road_6_20";
                    } else if (i == arrayStyle.length - 1) {
                        arrayStyle[i] = "road_6_22"; //maxim
                    } else if (i == arrayStyle.length - 3) {
                        arrayStyle[i] = "road_6_24";
                    } else {
                        arrayStyle[i] = "road_6_24";
                    }
                }
            }
            var newMIN = (arrayStyle[5] - arrayStyle[3]) / 2;
            var newMAX = (arrayStyle[arrayStyle.length - 2] - arrayStyle[arrayStyle.length - 4]) / 2;
            arrayStyle[3] = arrayStyle[3] + newMIN;
            arrayStyle[arrayStyle.length - 2] = arrayStyle[arrayStyle.length - 2] - newMAX;
            //console.info("arrayStyle",arrayStyle);
            return arrayStyle;
        }
    }, {
        key: "styleBetterRampFromStylesColor",
        value: function styleBetterRampFromStylesColor(_arrayStyle) {
            var arrayStyle = _arrayStyle;
            try {
                var newMIN = (arrayStyle[5] - arrayStyle[3]) / 2;
                var newMAX = (arrayStyle[arrayStyle.length - 2] - arrayStyle[arrayStyle.length - 4]) / 2;
                arrayStyle[3] = arrayStyle[3] + newMIN;
                arrayStyle[arrayStyle.length - 2] = arrayStyle[arrayStyle.length - 2] - newMAX;
                if (isNaN(newMIN) || isNaN(newMAX)) {
                    //	console.info("_arrayStyle",_arrayStyle);
                    return _arrayStyle;
                } else {
                    return arrayStyle;
                }
            } catch (err) {
                return _arrayStyle;
            }
            //return _arrayStyle;
        }
    }, {
        key: "joinTimesAndValues",
        value: function joinTimesAndValues(timestamps, JSONActiveFiles) {
            var maxValue = [];
            var map = new Map();
            timestamps.forEach(function (item, index) {
                var _newItem = (0, _moment2.default)(item).format("YYYY-MM-DD");
                var key = JSONActiveFiles[index];
                if (typeof key === "number") {
                    if (!map.has(_newItem)) {
                        map.set(_newItem, [key]);
                    } else {
                        map.get(_newItem).push(key);
                    }
                }
            });
            map.forEach(function (item) {
                maxValue.push(Math.max.apply(Math, _toConsumableArray(item)));
            });
            var sum = maxValue.reduce(function (a, b) {
                return a + b;
            }, 0);
            return {
                "sum": parseFloat(sum.toFixed(1)),
                "mean": parseFloat((sum / maxValue.length).toFixed(1))
            };
            /*
            const _newGA = [];
            for (let i = 0; i < timestamps.length; i++) {
            if (typeof JSONActiveFiles[i] === "number") {
            let _day = moment(timestamps[i]).format("YYYY-MM-DD");
            _newGA.push([timestamps[i], JSONActiveFiles[i]]);
            }
            }
            return _newGA;
            */
        }
    }]);

    return Share;
}();

module.exports = Share;
